import React, { useEffect, useRef, useState } from "react";
import ThreeDotIcon from "../Assets/svgs/ThreeDotIcon";
import { Button, Menu, MenuItem } from "@mui/material";

const TableActionMenu = ({ rowItem, actionMenus }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        className="btn p_0 border_0"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <ThreeDotIcon />
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {Array.isArray(actionMenus)
          ? actionMenus?.map((item, index) => (
              <MenuItem
                key={`${item?.title}-${index}`}
                sx={{
                  padding: ".70rem 1rem",
                  fontSize: ".75rem",
                  fontWeight: "400",
                  width: 160,
                }}
                onClick={() => {
                  handleClose();
                  if (typeof item?.onClick == "function") {
                    item?.onClick(rowItem);
                  }
                }}
              >
                {item?.title}
              </MenuItem>
            ))
          : null}
      </Menu>
    </>
  );
};

export default TableActionMenu;
